export const DISPLAY_TORCH_BUTTON = 'DISPLAY_TORCH_BUTTON'

export function torchButtonReducer (state = false, action) {
    switch (action.type){
        case DISPLAY_TORCH_BUTTON:
            return action.payload
        default: return state
    }
}